<template>
  <div class="md-layout">
    <div class="md-layout-item">
      <signup-card header-color="green" v-if="!registered">
        <h2 class="title text-center" slot="title">Registreren</h2>
        <md-field
          class="md-form-group"
          :class="getFirstNameErrorClass"
          slot="inputs"
        >
          <md-icon>face</md-icon>
          <label>Voornaam...</label>
          <md-input v-model="firstName"></md-input>
        </md-field>
        <md-field
          class="md-form-group"
          :class="getLastNamePrefixErrorClass"
          slot="inputs"
        >
          <md-icon>face</md-icon>
          <label>Tussenvoegsel...</label>
          <md-input v-model="lastNamePrefix"></md-input>
        </md-field>
        <md-field
          class="md-form-group"
          :class="getLastNameErrorClass"
          slot="inputs"
        >
          <md-icon>face</md-icon>
          <label>Achternaam...</label>
          <md-input v-model="lastName"></md-input>
        </md-field>
        <md-field
          class="md-form-group"
          :class="getEmailErrorClass"
          slot="inputs"
        >
          <md-icon>email</md-icon>
          <label>E-mailadres</label>
          <md-input v-model="email" type="email"></md-input>
        </md-field>
        <md-field
          class="md-form-group"
          :class="getPasswordErrorClass"
          slot="inputs"
        >
          <md-icon>lock_outline</md-icon>
          <label>Wachtwoord</label>
          <md-input v-model="password" type="password"></md-input>
        </md-field>
        <div class="button-container">
          <md-button
            slot="footer"
            class="md-button md-success md-lg"
            v-on:click="register()"
            :disabled="requesting"
          >
            Registreren
          </md-button>
        </div>
      </signup-card>
    </div>
  </div>
</template>
<script>
import { SignupCard } from "@/components";
export default {
  components: {
    SignupCard
  },
  data() {
    return {
      firstName: null,
      lastNamePrefix: null,
      lastName: null,
      email: null,
      password: null,
      registerErrors: {},
      requesting: false,
      registered: false
    };
  },
  methods: {
    register() {
      this.registerErrors = {};
      this.requesting = true;
      this.$http
        .post(
          this.$apiBaseUrl + "register",
          {
            email: this.email,
            password: this.password,
            firstName: this.firstName,
            lastNamePrefix: this.lastNamePrefix,
            lastName: this.lastName
          },
          { emulateJSON: true }
        )
        .then(
          response => {
            this.requesting = false;
            if (response.data.status === "success") {
              this.registered = true;
              this.notifyVue(
                "Succesvol geregistreerd",
                "add_alert",
                "success",
                5000
              );
            } else {
              this.registered = false;
              this.notifyVue(
                "Onbekende problemen bij het registreren",
                "add_alert",
                "danger",
                0
              );
            }
          },
          response => {
            this.requesting = false;
            this.registerErrors = response.data.errors;
            this.notifyVue(this.getErrorMessage, "add_alert", "danger", 0);
          }
        );
    },
    notifyVue(message, icon, type, timeout) {
      this.$notify({
        message: message,
        icon: icon,
        horizontalAlign: "center",
        verticalAlign: "top",
        type: type,
        timeout: timeout
      });
    }
  },
  computed: {
    getErrorMessage: function() {
      let msg =
        "Het volgende problemen is geconstateerd tijdens het registreren: ";
      for (let i in this.registerErrors) {
        if (i === "firstName" && this.registerErrors[i] === "missing") {
          msg += "Voornaam ontbreekt";
        } else if (i === "lastName" && this.registerErrors[i] === "missing") {
          msg += "Achternaam ontbreekt";
        } else if (i === "password" && this.registerErrors[i] === "missing") {
          msg += "Wachtwoord ontbreekt";
        } else if (i === "password" && this.registerErrors[i] === "too-short") {
          msg += "Wachtwoord is te kort. Gebruik minimaal 8 karakters";
        } else if (i === "password" && this.registerErrors[i] === "too-weak") {
          msg +=
            "Wachtwoord is te zwak. Gebruik hoofd en kleine letter, cijfers en speciale tekens om een wachtwoord samen te stellen";
        } else if (i === "email" && this.registerErrors[i] === "missing") {
          msg += "E-mailadres ontbreekt";
        } else if (i === "email" && this.registerErrors[i] === "invalid") {
          msg += "Ongelidig e-mailadres";
        } else if (i === "email" && this.registerErrors[i] === "duplicate") {
          msg += "Kan registratie niet voltooien met dit e-mailadres";
        } else {
          msg += "Onbekende fout!";
        }
      }

      return msg;
    },
    getFirstNameErrorClass: function() {
      return this.registerErrors.firstName !== undefined ? "md-error" : "";
    },
    getLastNameErrorClass: function() {
      return this.registerErrors.lastName !== undefined ? "md-error" : "";
    },
    getLastNamePrefixErrorClass: function() {
      return this.registerErrors.lastNamePrefix !== undefined ? "md-error" : "";
    },
    getEmailErrorClass: function() {
      return this.registerErrors.email !== undefined ? "md-error" : "";
    },
    getPasswordErrorClass: function() {
      return this.registerErrors.password !== undefined ? "md-error" : "";
    }
  }
};
</script>
<style></style>
